<template>
  <div>
    <el-checkbox v-model="showIcon">显示图标</el-checkbox>
      <div class="content-item mt12" v-if="showIcon">
        <img-icon-upload
          class="mb16"
          :imgSrc.sync="iconSrc"
          :iconType.sync="iconType"
          :iconColor.sync="iconColor"
          :resInfo.sync="resInfo"
        />
        <div v-show="iconSrc.length" class="content-item mb16 verticallyCenter">
          <span class="mr16 fs14">位置</span>
          <el-radio-group v-model="iconPosition">
            <el-radio label="left">左</el-radio>
            <el-radio label="right">右</el-radio>
          </el-radio-group>
        </div>
        <div class="verticallyCenter mb16" v-if="iconType === 'icon'">
          <span class="mr16 fs14">颜色</span>
          <cx-color-picker class="flex1" :isThemeColor.sync="iconColorIsThemeColor" :colorArr.sync="iconColor">
          </cx-color-picker>
        </div>

        <slider-and-input class="mb16" :value.sync="iconWidth" title="大小" :sliderMax="100" suffix="px" />
        <slider-and-input :value.sync="iconMargin" title="间距" :sliderMax="100" suffix="px" />
      </div>
  </div>
</template>
<script>
import complexSetMixin from "./complexSetMixin.js"
import { produce } from "immer";
export default {
  name: 'iconSet',
  mixins: [
    complexSetMixin()
  ],
  props: {
    defaultValue: undefined,
    config: undefined
  },
  computed: {
    showIcon: {
      get() {
        return this.configData.showIcon
      },
      set(newVal) {
        this.configData.showIcon = newVal
      }
    },
    iconSrc: {
      get() {
        return this.configData.iconSrc
      },
      set(newVal) {
        const tempIconType = this.tempIconType
        this.tempIconSrc = newVal
        this.configData = produce(this.configData, draft => {
          draft.iconSrc = newVal
          draft.iconType = tempIconType
        })
      }
    },
    iconType: {
      get() {
        return this.configData.iconType
      },
      set(newVal) {
        this.tempIconType = newVal
        this.configData = produce(this.configData, draft => {
          draft.iconType = newVal
        })
      }
    },
    iconWidth: {
      get() {
        return this.configData.iconWidth
      },
      set(newVal) {
        this.configData.iconWidth = newVal
      }
    },
    iconMargin: {
      get() {
        return this.configData.iconMargin
      },
      set(newVal) {
        this.configData = {...this.configData, iconMargin: newVal}
      }
    },
    iconColor: {
      get() {
        return this.configData.iconColor
      },
      set(newVal) {
        this.configData = {...this.configData, iconColor: newVal}
      }
    },
    iconColorIsThemeColor: {
      get() {
        return this.configData.iconColorIsThemeColor
      },
      set(newVal) {
        this.configData = {...this.configData, iconColorIsThemeColor: newVal}
      }
    },
    iconPosition: {
      get() {
        return this.configData.iconPosition
      },
      set(newVal) {
        this.configData = {...this.configData, iconPosition: newVal}
      }
    },
    resInfo: {
      get() {
        return this.configData.resInfo
      },
      set(newVal) {
        const tempIconSrc = this.tempIconSrc
        const tempIconType = this.tempIconType
        this.configData = produce(this.configData, draft => {
          draft.resInfo = newVal
          draft.iconSrc = tempIconSrc
          draft.iconType = tempIconType
        })
      }
    },
  }
}
</script>
<style lang="css" scoped>
</style>